<template>
  <div class="series-pack-list-item skeleton">
    <div class="left">
      <div class="pack-index"></div>
    </div>
    <div class="right">
      <div class="header">
        <div class="title"></div>
        <div class="meta">
          <div class="item node-count"></div>
          <div class="item duration"></div>
        </div>
      </div>
      <div class="series-pack-node-list skeleton">
        <SeriesPackNodeListItemSkeleton v-for="number in 8" :key="number" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import SeriesPackNodeListItemSkeleton from '@/series/components/series-pack-node-list-item-skeleton';

export default defineComponent({
  name: 'SeriesPackListItemSkeleton',

  /**
   * 属性
   */
  props: {
    pack: Object,
    current: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    //
    seriesPackNodeListItemStyles() {
      return {
        width: `${this.getRandomWidth(80, 160)}px`,
      };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    getRandomWidth(min, max) {
      return Math.random() * (max - min) + min;
    },
  },

  /**
   * 使用组件
   */
  components: {
    SeriesPackNodeListItemSkeleton,
  },
});
</script>

<style scoped>
@import './styles/series-pack-list-item-skeleton.css';
</style>
